import   React                          ,
       { useState                       ,
         useEffect                      }  from 'react';

import   classNames                        from 'classnames';

import   styles                            from './SoundSheet.module.scss';
import   { MediaGuideState }               from './MediaGuideBanner';

import { useTypedSelector               }  from '../../../store/useTypeSelector';
import { RootState                      }  from '../../../store/generalReducer';

import   Field                             from '../../widget/inputs/Field';
import   FieldSound                        from '../../widget/inputs/FieldSound';
import   Label                             from '../../widget/dataDisplay/labels/Label';
import   CreationIp                     from '../../widget/dataDisplay/labels/CreationIp';
import   TextArea                          from '../../widget/inputs/TextArea';
import   Toggle                            from '../../widget/inputs/Toggle';
import   Trigger                           from '../../widget/actuators/Trigger';
import   WidgetFrame                       from '../../widget/navigation/WidgetFrame';
import   Window                            from '../../widget/windows/window';

import   MediaSelector                     from './MediaSelector';

import { Sound                          ,
         initializedSound               }  from '../../../dataTypes/mediaManagment/sound_types';
import { Media                          }  from '../../../dataTypes/mediaManagment/types';

import { testTitle                      ,
         testSoundFileToUpload                   }  from '../../../dataTypes/mediaManagment/video_validators';

import { convertDateToString          }  from '../../../dataTypes/timeManagment/utils';


import { updateSound                    ,
         createSound                    ,
         getSoundById                   ,
         downloadSoundBlob              ,
         DownloadProgress               ,
		 getSoundUsage                  }  from '../../../backendServices/mediaManagment/api_sound';




import { getMediaList                   }  from '../../../backendServices/mediaManagment/api';



export interface SoundSheetProps {
                                   sound?    : Sound;
                                   onCreate? : ( id: number ) => void;
                                   onEdit?   : ( id: number ) => void ;
                                   // Création guidée (MediaSheet) : où en est la saisie.
                                   onGuideState? : ( state: MediaGuideState ) => void
                                 }

export const SoundSheet = ({ sound    ,
                             onCreate ,
                             onEdit   ,
                             onGuideState }: SoundSheetProps) => {

  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);
  const { categories     } = useTypedSelector((state: RootState) => state.mediaCategoryReducer);

  const isEditMode = sound !== undefined;

  const initialSound: Sound = isEditMode ? sound! : initializedSound ();

  const [ id                       , setId                       ] = useState (initialSound.id);
  const [ uuid                     ] = useState (initialSound.uuid);
  const [ creationDate             ] = useState (initialSound.creationDate);
  const [ active                   , setActive                   ] = useState (initialSound.active);
  const [ title                    , setTitle                    ] = useState (initialSound.title);
  const [ description              , setDescription              ] = useState (initialSound.description);
  const [ categoriesIds            ] = useState (initialSound.categoriesIds);
  const [ keywordsIds              ] = useState (initialSound.keywordsIds);
  
  const [ soundUsage               , setSoundUsage               ] = useState<number[]>([]);
  
  const [ soundFileToUpload        , setSoundFileToUpload        ] = useState<File | null>(null);  // Utilisé quand on choisit un fichier en local
  const [ soundSrc                 , setSoundSrc                 ] = useState ( '' );              // Contient l'url de type blob:// ...
  const [ soundFileName            , setSoundFileName            ] = useState ( '' );              // Contient le nom du fichier
  const [ soundLoading             , setSoundLoading             ] = useState ( false );
  const [ soundProgress            , setSoundProgress            ] = useState<DownloadProgress | null>(null);

  const [ titleMessage             , setTitleMessage             ] = useState ( '' );
  const [ descriptionMessage       ] = useState ( '' );
  const [ soundFileToUploadMessage , setSoundFileToUploadMessage ] = useState ( '' );

  const [ numberOfModifiedFields   , setNumberOfModifiedFields   ] = useState (   0   );
  const [ saved                    , setSaved                    ] = useState ( false );
  const [ error                    , setError                    ] = useState ( false );
  const [                  , setErrorMsg                 ] = useState (  ''   );
  const [ formError                , setFormError                ] = useState ( false );
  const [ saveButtonLock           , setSaveButtonLock           ] = useState ( false )
  const [ cancelAction             , setCancelAction             ] = useState ( false );


  const [ showImageSelector        , setShowImageSelector        ] = useState ( false );

  // Images existantes proposées dans le sélecteur ci-dessus, chargées à part de `mediaArray`
  // (store Redux non filtré par owner) pour ne proposer que les médias de l'admin courant.
  const [ selectorMediaSet         , setSelectorMediaSet         ] = useState<Media[]>([]);

  useEffect(() => {
    const loadSelectorMediaSet = async () => {
      const result = await getMediaList(['Image'], authentication.admin?.id);

      if (result.code === 1)
       {
        setSelectorMediaSet(result.payload);
       }
    };

    loadSelectorMediaSet();
  }, [authentication.admin?.id]);

  const [ warningShow              , setWarningShow              ] = useState ( false );

  useEffect(() => {
    if (onGuideState) onGuideState({ title, categoryChosen: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  let warningShowLock: boolean = false


  // useEffect(() => {

    // fetchData();
  // }, []);


const loadSoundBlob = async () => {

  console.log ('loadSoundBlob', initialSound.id)

  if (soundLoading || !isEditMode || soundSrc) return; // Ne charge qu'une fois
  
  setSoundLoading(true);
  setSoundProgress({ loaded: 0, total: 0 });
  
  try
   {
    const getSoundByIdResult = await getSoundById(initialSound.id);

  console.log ('loadSoundBlob', getSoundByIdResult)

    if (getSoundByIdResult.code === 1)
     {
      const completeSoundStruct = await downloadSoundBlob ( getSoundByIdResult.payload                    ,
                                                            (progress) => { setSoundProgress(progress); } );

  console.log ('loadSoundBlob', completeSoundStruct)

      if (completeSoundStruct.objectURL)
            {
             setSoundSrc(completeSoundStruct.objectURL);
             setSoundFileName(completeSoundStruct.soundFile ?? "");
            }
       else {
             console.error("objectURL is undefined");
            }
     }
   }
  catch (error)
   {
    console.error("Erreur lors du chargement du son:", error);
   }
  finally
   {
    setSoundLoading(false);
    setSoundProgress(null);
   }
};

// ============ USEEFFECT - MODIFICATION ============
// MODIFIÉ : Chargement automatique avec délai de 100ms pour ne pas bloquer le rendu

  const initSoundUsage = async () => {
	  
	const getSoundUsageResult = await getSoundUsage (initialSound.id)
 
    console.log ('initSoundUsage', getSoundUsageResult)
	
	if ( getSoundUsageResult.code === 1 )
	 {
	  setSoundUsage ( getSoundUsageResult.payload )
	 }
	  
  }


useEffect(() => {
  if (isEditMode && initialSound.soundFile) {
    const timer = setTimeout(() => {
      loadSoundBlob();
    }, 100);
    
    return () => clearTimeout(timer);
  }
  
 
}, []); // Uniquement au montage

useEffect(() => {

  initSoundUsage ()

}, []); // Uniquement au montage

// AJOUT : Nettoyage du blob au démontage
useEffect(() => {
  return () => {
    if (soundSrc && soundSrc.startsWith('blob:')) {
      URL.revokeObjectURL(soundSrc);
    }
  };
}, [soundSrc]);


  ///// Gestion de la vérification avant sauvegarde

  const check = (): boolean => {
    
    let test = true;

    const mess = testTitle ( title )
    
    setTitleMessage ( mess )
    
    test = test && ( mess === '' )

    if (soundSrc === '' && soundFileToUpload === null) 
          {
           setSoundFileToUploadMessage("Il manque le son");
           test = test && false;
          } 
     else {
           setSoundFileToUploadMessage("");
           test = test && true;
		   
		   console.log ('check', isEditMode, soundUsage, soundUsage.length)
		   
		   if ( isEditMode && soundUsage.length > 0 )
		    {
			 setWarningShow (true)
			 warningShowLock = true  // warningShow ne se met pas à jour tout de suite
			                         // donc save se lance quand même !!!
			}
          }

    return test    
  }

  ///// Gestion de la sauvegarde

  const save = async () => {

    // const titleErrorMessageBis             = testTitle             (title);
 
    // const soundFileToUploadErrorMessageBis = testSoundFileToUpload (soundFileToUpload === null ? undefined : soundFileToUpload);
 
    // const test = titleErrorMessageBis === "" &&
                 // ( ( soundSrc === '' && soundFileToUploadErrorMessageBis === "" ) || soundSrc !== '');

    console.log ('SoundSheet save authentication', authentication)

    if ( numberOfModifiedFields > 0  )
          {
           const result = isEditMode ?

                     await updateSound ( id                       ,
                                         active                   ,
										 title                    ,
                                         description              ,
                                         soundFileToUpload        ,
                                         categoriesIds            ,
                                         keywordsIds              ,
                                         false                    ,
                                         authentication.admin?.id )

                     :

                     await createSound ( active                   ,
					                     title                    ,
                                         description              ,
                                         soundFileToUpload        ,
                                         categoriesIds            ,
                                         keywordsIds              ,
                                         false                    ,
                                         authentication.admin?.id )

    console.log (result)

                if ( result.code === 1 )
                 {
                  // L'id doit passer par un état : une variable locale au corps du composant
                  // repart à zéro au rendu déclenché par setSaved, et l'acquittement final
                  // remontait donc l'id 0 à onCreate/onEdit. C'est aussi cet id qui permet
                  // de retrouver l'upload en arrière-plan dans le store.
                  if ( !isEditMode ) { setId ( result.payload ); }

                  setSaved    (true);
                  setError    (false);
                  setNumberOfModifiedFields (0);
                 }
                  
           else if ( result.code < 1)
                 {
                  setSaved    (true);
                  setError    (true);
                  setErrorMsg (result.comment);
                 }
          }
     else {
           setSaveButtonLock (false)
          }
  }

  const handleActiveChange = ( newState: boolean , id?: number | undefined) => {

    const fieldIsAlreadyModified = active !== initialSound.active;
    setActive (newState)

    if ( newState === initialSound.active &&  fieldIsAlreadyModified) { setNumberOfModifiedFields(prev => Math.max(0, prev - 1)); }
    if ( newState !== initialSound.active && !fieldIsAlreadyModified) { setNumberOfModifiedFields(prev => prev + 1);              }
  }

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    const fieldIsAlreadyModified = title !== initialSound.title

                      setTitle  ( e.target.value )
    setTitleMessage ( testTitle ( e.target.value ) )

    if ( e.target.value === initialSound.title &&  fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields - 1 ) }
    if ( e.target.value !== initialSound.title && !fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields + 1 ) }
  }

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {

    const fieldIsAlreadyModified = description !== initialSound.description

                            setDescription  ( e.target.value )
    //setDescriptionMessage ( testDescription ( e.target.value ) )

    if ( e.target.value === initialSound.description &&  fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields - 1 ) }
    if ( e.target.value !== initialSound.description && !fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields + 1 ) }
  }

  const handleSoundFileToUploadChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    if (event && event.target && event.target.files) {
      setSoundFileToUpload(event.target.files[0]);
      setSoundFileToUploadMessage(testSoundFileToUpload(event.target.files[0]));
      setNumberOfModifiedFields(prev => prev + 1);
    }
  };
  
  const handleSaveActionButton = () => {

    if ( check() )
          {
           if ( !saveButtonLock )
                 {
                  setSaveButtonLock (true)
				  
				  if ( !warningShowLock)
				   {
                    save ()
				   }
                 }
            else {
                  console.log ("LOCK")
                 }
          }
     else {
            setFormError (true)
          }
  }

  const handleCreationAckButton = () => {

    setSaved (false)
    setSaveButtonLock (false)

    if ( isEditMode )
          {
           if ( onEdit )
            {
             onEdit ( id )
            }
          }
     else {
           if ( onCreate )
            {
             onCreate ( id )
            }
          }
  }

  const handleErrorAckButton = () => {

    setSaved (false)
    setSaveButtonLock (false)
    window.scroll(0, 0);
  }

  const handleFormErrorAckButton = () => {

     setFormError (false)
  }

  ///// Gestion du bouton [ANNULER] qui permet de sortir de la saisie de la fiche
  
  const handleCancelActionButton = () => {

    setCancelAction (true)
  }

  const handleCancelButton_cancelAction = () => {

    setCancelAction (false)
    setSaved (false)
    setSaveButtonLock (false)
    window.scroll(0, 0);
  }

  const handleValidButton_cancelAction = () => {

    setCancelAction (false)

    if ( isEditMode )
          {
           if ( onEdit )
            {
             onEdit ( 0 )
            }
          }
     else {
           if ( onCreate )
            {
             onCreate ( 0 )
            }
          }
  }

  ///// Gestion de la fenêtre de sélection d'une image


  const handleImageSelectorCancel = () =>{

    setShowImageSelector (false)
  }
  
  const handleImageSelection = (id: number) => {

    setShowImageSelector(false);
  }

  const handleWarningAckButton = () => {
	  
    setWarningShow (false)	  
	warningShowLock = false
    save ()
  }
  

  return (

            <div className={classNames(styles.root)}>

              {
               showImageSelector &&
               <MediaSelector onCancel        = {handleImageSelectorCancel}
                              onSelect        = {handleImageSelection}
                              mediaSet        = {selectorMediaSet}
                              originalFilter  = {['Image']}
                              mediaCategories = {categories}
                              mediaTypeNames  = {['Image']} />
              } 

              {
               warningShow &&
               <Window message                 = {<>Ce son est utilisé dans d'autres<br/>
			                                         médias qui devront être retranscodés</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleWarningAckButton}   />
              }

              {
               formError &&
               <Window message                 = {<>La fiche contient des erreurs</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleFormErrorAckButton}   />
              }

              {
               saved && error &&
               <Window message                 = {<>Une erreur est survenue lors de la création de la fiche</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleErrorAckButton}   />
              }

              {
               // L'upload du fichier se poursuit en tâche de fond après cet acquittement :
               // il est suivi par TaskManager, dans le header.
               saved && !error &&
               <Window message                 = {isEditMode ? <>Fiche modifiée</> : <>Fiche créée</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleCreationAckButton}
                       validButtonText         = "Ok" />
              }
             
              {
               cancelAction &&
               <Window message                 = {<>Etes-vous sûr de vouloir annuler vos saisies ?</>}
                       messageType             = "question"
                       onClickOnCancelButton   = {handleCancelButton_cancelAction}
                       onClickOnValidateButton = {handleValidButton_cancelAction}   />
              }

              <div className={classNames(styles.contain)}>

                {/* Même présentation que la fiche vidéo : Id / Uuid / Date / IP dans un
                    bandeau à part, au-dessus du bloc des éléments du média. */}
                {
                 isEditMode &&
                 <div className={classNames(styles.topBar)}>
                   <WidgetFrame name               = "Id :"
                                error              = ""
                                labelTextPosition  = "right"
                                labelBlockPosition = "left" >
                     <p className = {classNames(styles.text)}>{id}</p>
                   </WidgetFrame>
                   <WidgetFrame name               = "Uuid :"
                                error              = ""
                                labelTextPosition  = "right"
                                labelBlockPosition = "left" >
                     <p className = {classNames(styles.text)}>{uuid}</p>
                   </WidgetFrame>
                   <Label value = {`Date de création : ${convertDateToString(creationDate, 'dd/MM/yyyy HH:mm')}`} />
                   <CreationIp ipAddress = {initialSound.creationIpAddress} />
                 </div>
                }

                <div className={classNames(styles.form)}>

                  <div className={classNames(styles.active)}>
                    <WidgetFrame name               = "Actif :"
                                 labelTextPosition  = "right"
                                 labelBlockPosition = "left"
                                 classNameGrid      = {classNames(styles.grid_frame)} >
                      <Toggle checked  = {active}
                              onChange = {handleActiveChange}
                              form     = "switch" />
                    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.left)}>
                    <div className={classNames(styles.title)} data-guide="title">
                      <WidgetFrame name               = "Titre :"
                                   error              = {titleMessage}
                                   labelTextPosition  = "right"
                                   labelBlockPosition = "left"
                                   classNameGrid      = {classNames(styles.grid_frame)} >
                          <Field  type          = "text"
                                  placeholder   = ""
                                  value         = {title}
                                  onChange      = {handleTitleChange} />
                      </WidgetFrame>
                    </div>

                    <div className={classNames(styles.description)}>
                      <WidgetFrame name               = {onGuideState ? "Description (facultatif) :" : "Description :"}
                                   error              = {descriptionMessage}
                                   labelTextPosition  = "right"
                                   labelBlockPosition = "left"
                                   classNameGrid      = {classNames(styles.grid_frame)} >
                        <TextArea placeholder   = ""
                                  value         = {description}
                                  onChange      = {handleDescriptionChange} />
                      </WidgetFrame>
                    </div>
                  </div>

                  <div className={classNames(styles.sound)}>
                    <WidgetFrame name               = "Son :"
                                 error              = {soundFileToUploadMessage}
                                 labelTextPosition  = "right"
                                 labelBlockPosition = "left"
                                 classNameGrid      = {classNames(styles.grid_frame2)} >
                      <FieldSound value    = {soundFileName}          // affiche le nom d’origine
                                  mediaURL = {soundSrc}            // pour le player
                                  onChange = {handleSoundFileToUploadChange} 
                isLoading    = {soundLoading}
                loadProgress = {soundProgress} />
                    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.buttons)}>
                    <div className={classNames(styles.bloc)}>
                      <Trigger name    = "Annuler" 
					           onClick = {handleCancelActionButton} 
							   variant = "tailwind2" />
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <Trigger {...(isEditMode && numberOfModifiedFields > 0 ? { buttonBackgroundColor: "#DC2626", buttonBackgroundHoverColor: "#B91C1C", buttonForegroundColor: "#fff", buttonForegroundHoverColor: "#fff" } : {})} name    = {isEditMode?`Enregistrer${numberOfModifiedFields > 0 ? ` (${numberOfModifiedFields})` : ""}`:"Créer"} 
					           onClick = {handleSaveActionButton} 
							   variant = "tailwind2" 
							   unavailable={isEditMode && numberOfModifiedFields === 0} />
                      &nbsp;&nbsp;
                      {
                       numberOfModifiedFields > 0 && isEditMode &&
                       ( <p className={styles.modBadge} > {numberOfModifiedFields} modification{numberOfModifiedFields > 1 ? "s" : ""} </p> )
                      }
                    </div>
                  </div>

                </div>

              </div>

           </div>

         );


};


export default SoundSheet;
